import { type JSX, type ParentComponent, splitProps } from "solid-js";
import { cn } from "@/libs/cn";

export const AuthTitle: ParentComponent<
  JSX.HTMLAttributes<HTMLHeadingElement>
> = (props) => {
  const [local, rest] = splitProps(props, ["children", "class", "classList"]);
  return (
    <h1
      class={cn("text-2xl font-medium text-left", local.class)}
      classList={local.classList}
      {...rest}
    >
      {props.children}
    </h1>
  );
};

export const AuthDescription: ParentComponent<
  JSX.HTMLAttributes<HTMLParagraphElement>
> = (props) => {
  const [local, rest] = splitProps(props, ["children", "class", "classList"]);
  return (
    <p
      class={cn("text-md text-muted-foreground text-left", local.class)}
      classList={local.classList}
      {...rest}
    >
      {props.children}
    </p>
  );
};

export const AuthHeader: ParentComponent<JSX.HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const [local, rest] = splitProps(props, ["children", "class", "classList"]);
  return (
    <div
      class={cn("flex flex-col gap-2", local.class)}
      classList={local.classList}
      {...rest}
    >
      {props.children}
    </div>
  );
};

export const AuthFormBox: ParentComponent<
  JSX.HTMLAttributes<HTMLDivElement>
> = (props) => {
  const [local, rest] = splitProps(props, ["children", "class", "classList"]);
  return (
    <div
      class={cn("flex flex-col gap-4 lg:gap-8", local.class)}
      classList={local.classList}
      {...rest}
    >
      {props.children}
    </div>
  );
};

export const AuthContainer: ParentComponent<
  JSX.HTMLAttributes<HTMLDivElement>
> = (props) => {
  const [local, rest] = splitProps(props, ["children", "class", "classList"]);
  return (
    <div
      class={cn("max-w-xl min-h-96 w-full rounded-lg", local.class)}
      classList={local.classList}
      {...rest}
    >
      {props.children}
    </div>
  );
};
